export default "__VITE_ASSET__DCMUwGAM__"